/**
 * Les refus de Supabase, dits en français.
 *
 * Supabase renvoie des messages anglais et des codes. On traduit ceux qu'un
 * utilisateur rencontre réellement ; le reste devient un message générique qui
 * ne laisse pas croire à une faute de frappe.
 */
export function messageDeRefus(erreur: {
  message?: string | undefined;
  code?: string | undefined;
  status?: number | undefined;
}): string {
  const code = erreur.code ?? '';
  const message = (erreur.message ?? '').toLowerCase();

  if (code === 'invalid_credentials' || message.includes('invalid login credentials')) {
    return 'E-mail ou mot de passe incorrect.';
  }
  if (code === 'email_not_confirmed' || message.includes('email not confirmed')) {
    return 'Votre adresse n’est pas encore confirmée. Ouvrez le lien reçu par e-mail.';
  }
  if (
    code === 'otp_disabled' ||
    code === 'signup_disabled' ||
    message.includes('signups not allowed')
  ) {
    return 'Aucun compte n’existe pour cette adresse. Demandez une invitation au bureau.';
  }
  if (code === 'over_email_send_rate_limit' || erreur.status === 429) {
    return 'Trop de demandes rapprochées. Réessayez dans une minute.';
  }
  /* Avant le mot de passe faible : « New password should be different… »
     contient lui aussi « password should be ». */
  if (code === 'same_password' || message.includes('should be different')) {
    return 'C’est déjà votre mot de passe actuel : choisissez-en un autre.';
  }
  if (code === 'weak_password' || message.includes('password should')) {
    const longueur = /at least (\d+) characters/.exec(message)?.[1];
    if (longueur) return `Mot de passe trop court : ${longueur} caractères au moins.`;
    if (message.includes('pwned') || message.includes('leak')) {
      return 'Ce mot de passe circule dans des fuites de données connues : choisissez-en un autre.';
    }
    return 'Mot de passe trop simple : mélangez lettres, chiffres et symboles.';
  }
  if (message.includes('failed to fetch') || message.includes('network')) {
    return 'Connexion au serveur impossible. Vérifiez votre réseau.';
  }
  return 'La demande n’a pas abouti. Réessayez, ou prévenez le bureau si cela persiste.';
}
